import SearchResult from "./SearchResult";

const SearchResults = ({ items }) => (
  <div className="search-results">
    {items.map((item) => (
      <div className="block search-result" key={item.document.id}>
        <SearchResult item={item} />
      </div>
    ))}
  </div>
);

export default SearchResults;
